import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';
import React from 'react';
import { IMenuItem } from './interfaces';

export const MenuItem: React.FC<IMenuItem> = ({
  key,
  label,
  icon,
  postIcon,
  onClick,
  sx,
  sxButton,
  active = false,
  gutter = false,
}): JSX.Element => {
  const theme = useTheme();

  return (
    <ListItem
      key={key}
      sx={{
        color: active
          ? theme.palette.getContrastText(theme.palette.primary.main)
          : null,
        '&:not(:last-child)': {
          mb: gutter ? '20px' : '5px',
        },
        ...sx,
      }}
      disablePadding
    >
      <ListItemButton
        sx={{
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.main,
            },
          },
          borderRadius: '5px',
          paddingY: '5px',
          paddingX: '12px',
          mx: '5px',
          ...sxButton,
        }}
        selected={active}
        onClick={onClick}
      >
        <ListItemIcon
          sx={{
            minWidth: '31px',
            '& svg': {
              fontSize: '20px',
              color: active
                ? theme.palette.getContrastText(theme.palette.primary.main)
                : null,
            },
          }}
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={label}
          primaryTypographyProps={{
            fontSize: 14,
          }}
        />
        {postIcon && (
          <ListItemIcon
            sx={{
              minWidth: '21px',
              '& svg': {
                fontSize: '20px',
                color: active
                  ? theme.palette.getContrastText(theme.palette.primary.main)
                  : null,
              },
            }}
            style={{ marginLeft: 'auto' }}
          >
            {postIcon}
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
};
